/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import * as S from './styles';

export interface IHeroContentProps {
  title?: string;
  subtitle?: string;
}

export const HeroContent = (props: IHeroContentProps) => {
  const { title, subtitle } = props;
  return (
    <>
      <S.Title>{title}</S.Title>
      <S.SubTitle>{subtitle}</S.SubTitle>
    </>
  );
};

HeroContent.defaultProps = {
  title: '',
  subtitle: '',
};
